import "bijou/base";

// ======= Show/set individual address fields functions =======

const showAddressFields = () =>
  $(".address-autocomplete-group").removeClass("hide-address-questions");

const showAddressFieldsGroup = () =>
  $(".hidden_on_autocomplete").removeClass("hidden_on_autocomplete");

const scrollToAddressFields = () => {
  const firstAddressField = $(".address-fields input").first();
  firstAddressField.trigger("focus");
  $("html, body").animate(
    {
      scrollTop: firstAddressField.closest(".control-block").offset().top,
    },
    "fast",
  );
};

const manualEntryClickListeners = () =>
  $(".address-autocomplete-group").delegate(".enter-manually", "click", () => {
    showAddressFields();
    showAddressFieldsGroup();
    scrollToAddressFields();
    window.EventTracker?.trigger("enter_contact_details_manually_cta_clicked");
  });

const setAddressFields = ({
  street,
  subBuilding,
  city,
  provinceName,
  adminAreaName,
  postalCode,
}) => {
  const group = $(".address-autocomplete-group");
  const { questionMapping } = group
    .find(".autocomplete-input-container input")
    .data();

  group.find(`#${questionMapping.street}`).val(street);
  group.find(`#${questionMapping.subBuilding}`).val(subBuilding);
  group.find(`#${questionMapping.city}`).val(city);
  group.find(`#${questionMapping.provinceName}`).val(provinceName);
  group.find(`#${questionMapping.adminAreaName}`).val(adminAreaName);
  group.find(`#${questionMapping.postalCode}`).val(postalCode).trigger("input");

  showAddressFields();

  $(".address-fields input").each((_, input) => {
    $("#js-questionnaire form").validate().element(input);
  });
};

export { showAddressFields, manualEntryClickListeners, setAddressFields };
